import { computed } from 'vue';
import { useRoute } from 'vue-router';
import ToFlutterService from '@/services/ToFlutterService';
import { NAVIGATION_PAGES, UPLOAD_PLACES } from '@/types/enums';
import { blobToUrl, getVideoThumbnail } from '@/helpers/videoThumbnail';
import { IImageCrop } from '@/types/interfaces';

export default function useFlutter() {
  const route = useRoute();
  const currentPage = computed(() => route.meta.navigationPage);

  function flutterOpenCamera() {
    ToFlutterService.openCamera();
  }

  function flutterOpenImagePicker() {
    ToFlutterService.openImagePicker();
    // const folderId = currentPage.value === NAVIGATION_PAGES.DRIVE_FOLDER ? route.params.id as string : '';
    // const location = folderId ? UPLOAD_PLACES.FOLDER_PHOTO : UPLOAD_PLACES.MIXED_PHOTO;
    // ToFlutterService.openImagePicker(location, folderId);
  }

  function flutterOpenFilePicker() {
    ToFlutterService.openFilePicker();
    // const folderId = currentPage.value === NAVIGATION_PAGES.DRIVE_FOLDER ? route.params.id as string : '';
    // const location = folderId ? UPLOAD_PLACES.FOLDER : UPLOAD_PLACES.MIXED;
    // ToFlutterService.openFilePicker(
    //   isDialog ? UPLOAD_PLACES.DIALOG : location,
    //   isDialog ? conversationId : folderId,
    // );
  }

  async function flutterAddMedia(mediaFile: File) {
    let poster = '' as unknown | undefined | string;

    if (mediaFile.type.includes('video')) {
      const thumbnailBlob = await getVideoThumbnail(mediaFile, 1.0);
      poster = blobToUrl(thumbnailBlob);
    }

    return {
      url: URL.createObjectURL(mediaFile),
      fileName: mediaFile.name,
      fileType: mediaFile.type,
      poster,
    } as IImageCrop;
  }

  return {
    flutterOpenCamera,
    flutterOpenImagePicker,
    flutterOpenFilePicker,
    flutterAddMedia,
  };
}
